import axios from "axios";
import { api } from "./helper";
import store from "../../store/store";
import { v4 as uuidv4 } from "uuid";

function prepareDataRequest(data) {
  return { RequestCorrelationId: uuidv4(), Data: data };
}
export function prepareRequest(data) {
  return { ...data, RequestCorrelationId: uuidv4() };
}

const client = axios.create({ baseURL: api, withCredentials: false });

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function CreateSubrogation(item) {
  return client.post("Subrogations/CreateSubrogation", prepareDataRequest(item));
}
function GetSubrogations() {
  return client.post("Subrogations/GetSubrogations", prepareRequest({}));
}

function GetApprovedSubrogations(item) {
  const {
    dateFrom, dateTo, stage, searchType, searchText, page, pageSize
  } = item;
  return client.post(
    "Subrogations/GetApprovedSubrogations",
    prepareRequest({
      dateFrom, dateTo, stage, searchType,
      searchText: (searchText ?? "").trim() ? searchText.trim() : null,
      page, pageSize
    })
  );
}

function GetSubrogationInfo(claimId) {
  return client.post("Subrogations/GetSubrogationInfo", prepareRequest({ claimId }));
}

function UpdateSubrogationAmount(item) {
  return client.post("Subrogations/UpdateSubrogationAmount", prepareDataRequest(item));
}

function UpdateSubrogationStatus(item) {
  return client.post("Subrogations/UpdateSubrogationStatus", prepareRequest(item));
}

function LastSubrogationStatus(id) {
  var item = { id: id };
  return client.post("Subrogations/LastSubrogationStatus", prepareRequest(item));
}

function GetSubrogationById(id) {
  return client.post("Subrogations/GetSubrogationById", prepareRequest({ id }));
}

//payment
function CreatePayment(item) {
  return client.post("Payments/CreatePayment", prepareDataRequest(item));
}
function CreateCompletedPayment(item) {
  return client.post("Payments/CreateCompletedPayment", prepareDataRequest(item));
}
function UpdatePayment(item) {
  return client.post("Payments/UpdatePayment", prepareDataRequest(item));
}
function UpdateCompletedPayment(item) {
  return client.post("Payments/UpdateCompletedPayment", prepareDataRequest(item));
}
function GetPayments(participantId) {
  return client.post("Payments/GetPayments", prepareRequest({ participantId }));
}
function GetCompletedPayments(participantId) {
  return client.post("Payments/GetCompletedPayments", prepareRequest({ participantId }));
}
function DeletePayment(id, uid) {
  console.log("Deleting payment with id:", id, "by user:", uid);
  return client.post("Payments/DeletePayment", prepareDataRequest({ id, commandUserId: uid }));
}
function DeleteCompletedPayment(id, uid) {
  return client.post("Payments/DeleteCompletedPayment", prepareDataRequest({ id, commandUserId: uid }));
}
function GenerateInstallments(item) {
  return client.post("Payments/GenerateInstallments", prepareDataRequest(item));
}
function DeleteInstallments(participantId) {
  return client.post(
    "Payments/DeleteInstallments",
    prepareDataRequest({ ParticipantId: participantId })
  );
}



export {
  CreateSubrogation,
  GetSubrogations,
  GetSubrogationInfo,
  UpdateSubrogationAmount,
  CreatePayment,
  GetPayments,
  UpdatePayment,
  GenerateInstallments,
  DeleteInstallments,
  GetCompletedPayments,
  CreateCompletedPayment,
  UpdateCompletedPayment,
  LastSubrogationStatus,
  UpdateSubrogationStatus,
  GetSubrogationById,
  GetApprovedSubrogations,
  DeletePayment,
  DeleteCompletedPayment
}